<script>
    import {twMerge} from "$m7-library/lib/twMerge";

    let {
        label = '',
        value = $bindable(),
        name = '',
        class: cls = '',
        'data-checkout-action': checkoutAction = null,
        onchange = null,
    } = $props();

    /* decision: [1] eigene Marke */
    const labelCls = $derived(twMerge("tw:text-sm tw:font-medium tw:text-gray-900 tw:relative tw:w-full tw:flex tw:items-center tw:gap-2 tw:cursor-pointer tw:has-focus-visible:outline-2 tw:outline-offset-2", cls));

    /* Kaestchen und Haken ohne eigene CSS-Regel: der Haken ist ein gedrehtes ::after mit
       zwei Raendern. Ein Hintergrundbild als data:-URI ginge nicht — Tailwind laesst in
       Arbitraer-Werten keine Leerzeichen zu, und ein SVG hat welche. */
    const hakenCls = "tw:relative tw:shrink-0 tw:size-4 tw:rounded-sm tw:border-2 tw:border-solid tw:border-cyprus tw:peer-checked:bg-cyprus"
        + " tw:after:content-[''] tw:after:absolute tw:after:left-1/2 tw:after:top-1/2 tw:after:h-2 tw:after:w-1"
        + " tw:after:-translate-x-1/2 tw:after:-translate-y-[60%] tw:after:rotate-45"
        + " tw:after:border-r-2 tw:after:border-b-2 tw:after:border-solid tw:after:border-orange"
        + " tw:after:opacity-0 tw:peer-checked:after:opacity-100";
</script>

<label class={labelCls}>
    <input type="checkbox"
           class="tw:peer tw:absolute tw:-z-10 tw:opacity-0"
           name={`shadow_${name}`}
           data-checkout-action={checkoutAction}
           checked={value}
           onchange={(e) => { // @ts-ignore
               value = e.currentTarget.checked;
               if (onchange) onchange(e.currentTarget.checked);
           }}>
    <span class={hakenCls} aria-hidden="true"></span>
    <span>{@html label}</span>
</label>